<template>
    <div class="w-auto">
        <v-loading-cancel-button :loading="loading" :x-small="true" @clicked="$emit('clicked', {row, link})">
            <i class="fas fa-copy text-sm"></i>
        </v-loading-cancel-button>
    </div>
</template>

<script>
    import LoadingCancelButton from './../_Form/LoadingCancelButton';
    export default {
        props: ['loading', 'row', 'link'],
        components: {
            'v-loading-cancel-button': LoadingCancelButton
        }
    }
</script>